import { Box } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { Txt } from '@app/components/common';

const parseVisitWeeks = (value: string, charsPerWeek: number) => {
  const chars = value.split('').map(Number);
  return [0, 1, 2, 3].map((weekIndex) => {
    const offset = weekIndex * charsPerWeek;
    return chars.slice(offset + 1, offset + charsPerWeek);
  });
};

export const FrequencyVisitsView = ({ value, setFrequency }: { value?: string; setFrequency?(value: number): void }) => { 
  const [days, setDays] = useState<number[][]>([[1], [], [], []]);
  useEffect(() => {
    if (!value || Number.isNaN(Number(value))) {
      setFrequency?.(1);
      setDays([[1], [], [], []]); 
      return;
    }
    const days: number[][] = [[], [], [], []];
    switch(value.length) {
      case 2: { // 1 days per month
        setFrequency?.(1);
        const [week, day] = value.split('');
        days[Number(week) - 1] = [Number(day)];
        setDays(days); 
        break;
      }
      case 4: { // 2 days per month
        setFrequency?.(2);
        const [w1, w1d, w2, w2d] = value.split('');
        days[Number(w1) - 1] = [Number(w1d)];
        days[Number(w2) - 1] = [Number(w2d)];
        setDays(days); 
        break;
      }
      case 8: { // 4 days per month
        setFrequency?.(4);
        const [_, w1d, __, w2d, ___, w3d, ____, w4d] = value.split('');
        setDays([[Number(w1d)], [Number(w2d)], [Number(w3d)],  [Number(w4d)]]); 
        break;
      }
      case 12: { // 8 days per month
        setFrequency?.(8);
        const [w1, w1d1, w1d2, w2, w2d1, w2d2, w3, w3d1, w3d2, w4, w4d1, w4d2] = value.split('');
        setDays([
          [Number(w1d1), Number(w1d2)], 
          [Number(w2d1), Number(w2d2)], 
          [Number(w3d1), Number(w3d2)],  
          [Number(w4d1), Number(w4d2)]
        ]); 
        break;
      }
      case 16: { // 12 days per month
        setFrequency?.(12);
        const [w1, w1d1, w1d2, w1d3, w2, w2d1, w2d2, w2d3, w3, w3d1, w3d2, w3d3, w4, w4d1, w4d2, w4d3] = value.split('');
        setDays([
          [Number(w1d1), Number(w1d2), Number(w1d3)], 
          [Number(w2d1), Number(w2d2), Number(w2d3)], 
          [Number(w3d1), Number(w3d2), Number(w3d3)],  
          [Number(w4d1), Number(w4d2), Number(w4d3)]
        ]); 
        break;
      }
      case 20: { // 16 days — 4/нед
        setFrequency?.(16);
        setDays(parseVisitWeeks(value, 5));
        break;
      }
      case 24: { // 20 days — 5/нед
        setFrequency?.(20);
        setDays(parseVisitWeeks(value, 6));
        break;
      }
      case 28: { // 24 days — 6/нед
        setFrequency?.(24);
        setDays(parseVisitWeeks(value, 7));
        break;
      }
      case 32: { // 28 days — 7/нед
        setFrequency?.(28);
        setDays(parseVisitWeeks(value, 8));
        break;
      }
      default: {
        setFrequency?.(1);
        setDays([[1], [], [], []]); 
      }
    }
  }, [value]);
  return <>
    <Box 
      borderColor="gray.500" 
      borderWidth={1} borderRadius={8} 
      marginTop={2} padding={1} gap={1}
      flexDirection="column"
      alignItems="center"
      display='flex'
      flexDir='column'
      minWidth={390}
    >
      <Box display="flex" flexDirection="row" alignItems="center">
        <Box 
          display='flex' justifyContent='center'
          backgroundColor={days[0].length ? 'brand.100' : 'brand.500'} 
          color='white'  minWidth="64px" height="24px"
          borderRadius={12} alignItems="center"
          marginRight={4}
        >1 нед</Box>
        <Week 
          selectedDays={days[0]} 
          isActive={!!days[0].length} 
        />
      </Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Box 
          display='flex' justifyContent='center'
          backgroundColor={days[0].length ? 'brand.100' : 'brand.500'} 
          color='white'  minWidth="64px" height="24px"
          borderRadius={12} alignItems="center"
          marginRight={4}
        >2 нед</Box>
        <Week 
          selectedDays={days[1]} 
          isActive={!!days[1].length} 
        />
      </Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Box 
          display='flex' justifyContent='center'
          backgroundColor={days[0].length ? 'brand.100' : 'brand.500'} 
          color='white'  minWidth="64px" height="24px"
          borderRadius={12} alignItems="center"
          marginRight={4}
        >3 нед</Box>
        <Week
          selectedDays={days[2]} 
          isActive={!!days[2].length} 
        />
      </Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Box 
          display='flex' justifyContent='center'
          backgroundColor={days[0].length ? 'brand.100' : 'brand.500'} 
          color='white'  minWidth="64px" height="24px"
          borderRadius={12} alignItems="center"
          marginRight={4}
        >4 нед</Box>
        <Week 
          selectedDays={days[3]} 
          isActive={!!days[3].length} 
        />
      </Box>
    </Box>
  </>;
};



const weekDays = [
  { id: 1, label: 'ПН' },
  { id: 2, label: 'ВТ' },
  { id: 3, label: 'СР' },
  { id: 4, label: 'ЧТ' },
  { id: 5, label: 'ПТ' },
  { id: 6, label: 'СБ' },
  { id: 7, label: 'ВС' },
];

const Week = ({selectedDays, isActive}: { 
  selectedDays: number[], 
  isActive: boolean, 
}) => {

  return <Box 
    display="flex" 
    flexDirection="row" 
    borderRadius={8} 
    backgroundColor={isActive ? 'light.300' : 'gray.300'} 
    padding='2px'
    gap="2px"
    position='relative'
  >
    {weekDays.map(({ id, label }) => <Box key={id} >
      <Box 
        padding='2px'
        backgroundColor={selectedDays.includes(id) ? 'brand.500' : 'transparent'}
        borderRadius={6} width="40px" justifyContent="center"
        cursor='pointer'
      >
        <Txt style={{ textAlign: 'center', color: selectedDays.includes(id) ? 'white' : 'black' }} >{label}</Txt>
      </Box>
    </Box>)}
  </Box>;
};